import script from "./VButtonDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./VButtonDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./VButtonDropdown.vue?vue&type=style&index=0&id=4d82dbac&lang=scss"

const __exports__ = script;

export default __exports__